import createComponent from '@carvana/merch-components/createComponent';
import { TranslucentCard } from '../Hero.styles';

export const TilesWrapper = createComponent(TranslucentCard, {
  className: 'flex flex-col rounded-lg text-text-inverse t-heading-sm',
  rounded: 'lg'
});
